import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './event-form-status.style';

export type EventFormGoneProps = {
  onClose: () => void;
};

export const EventFormGone: React.FC<EventFormGoneProps> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Styled.Container>
      <Typography variant="h2">{t('forms.event.gone.title')}</Typography>
      <Typography variant="overline">
        {t('forms.event.gone.description')}
      </Typography>
      <Styled.Interactions>
        <Button size={Sizes.Medium} onClick={onClose} type="button">
          {t('forms.event.gone.close.label')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};

export type EventFormErrorProps = {
  // what the provider actually refused, when it said — falls back to the generic description
  description?: string;
  onRetry: () => void;
  onCancel: () => void;
};

export const EventFormError: React.FC<EventFormErrorProps> = ({
  description,
  onRetry,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Styled.Container>
      <Typography variant="h2">{t('forms.event.error.title')}</Typography>
      <Typography variant="overline">
        {description ?? t('forms.event.error.description')}
      </Typography>
      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          onClick={onCancel}
          type="button"
        >
          {t('forms.event.error.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} onClick={onRetry} type="button">
          {t('forms.event.error.retry.label')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
